import request from "../../utils/request";

export function getOverview(params) {
  return request({
    url: "/dashboard/overview",
    method: "get",
    params,
    timeout: 120000
  });
}
